<template>
	<div class="cart">
		<FormulateForm ref="form" v-model="form" @submit="save">
			<Loader :show="loading" />
			<div class="row">
				<div class="col-12 col-md-7">
					<div class="" v-sticky sticky-offset="{top: 100}" sticky-z-index="20">
						<h2 class="mt-4">Finalizar compra</h2>
						<div class="section-title">
							<p class="text-white">.</p>
							<div class="label">Detalle del pedido</div>
						</div>
						<div class="mt-2 p-3">
							<div v-if="!cart || cart.products.length <= 0" class="alert alert-default">
								Aún no has agregado ningún producto al carrito de compras.
							</div>
							<div v-if="cart && cart.products.length > 0">
								<CartProductsTable :cart="cart" :editable="true" />
							</div>
						</div>
					</div>
				</div>
				<div class="col-12 col-md-5">
					<div class="side-content mt-4">
						<div class="section-title">
							<div class="label">Datos personales</div>
							<p>Complete sus datos personales para poder finalizar su compra</p>
						</div>

						<div class="p-3 mt-1">
							<FormulateInput label="Nombre" name="name" ref="first" validation-name="Nombre" validation="required" />

							<FormulateInput label="Apellido" name="lastname" validation-name="Apellido" validation="required" />

							<FormulateInput label="Correo electrónico" name="email" type="email" validation-name="Email" validation="required" />
							<FormulateInput label="Teléfono" type="phone" name="phone" validation-name="Teléfono" validation="required" />
						</div>
						<div class="section-title mt-4">
							<div class="label">Datos de facturación</div>
							<p></p>
						</div>

						<div class="p-3 mt-1">
							<FormulateInput label="Razón social" name="businessName" />
							<FormulateInput label="RUT" name="businessRut" />
						</div>
						<div class="section-title mt-4">
							<div class="label">Método de envío</div>
							<p>Seleccione como desea hacerse de su compra</p>
						</div>

						<div class="p-3 mt-1">
							<FormulateInput
								name="deliveryMethod"
								:options="{ OFFICE: 'Retiro en local', DELIVERY: 'Envío a domicilio' }"
								type="select"
								placeholder="Seleccione una opción"
								validation-name="Forma de envío"
								validation="required"
							/>

							<div v-if="form.deliveryMethod == 'DELIVERY'">
								<FormulateInput label="Agencia de envío" name="deliveryAgency" validation-name="Agencia" validation="required" help="Indique su agencia de preferencia para que le enviemos su compra" />
								<FormulateInput label="Localidad" name="deliveryLocality" validation-name="Localidad" validation="required" />
								<FormulateInput label="Dirección" name="deliveryAddress" validation-name="Dirección" validation="required" />
								<FormulateInput type="textarea" name="deliveryComments" label="Comentarios" validation="optional|max:200,length" validation-name="Comentarios" />
							</div>
						</div>
					</div>

					<div class="side-content">
						<div class="p-3 ">
							<FormulateInput type="submit" name="Finalizar compra" v-if="cart && productsValidated">
								<template>
									<div class="btn btn-primary w-100">Finalizar compra y pagar</div>
								</template>
							</FormulateInput>

							<template v-else>
								<div class="btn btn-secondary w-100 opacity-2 disabled">Finalizar compra y pagar</div>
							</template>
						</div>
					</div>
				</div>
			</div>
		</FormulateForm>
	</div>
</template>

<script>
import gql from 'graphql-tag'
import ecommerceMixins from './mixins'
import Loader from '@/components/Loader'
import CartProductsTable from './CartProductsTable'

export default {
	name: 'Checkout',
	mixims: [ecommerceMixins],
	components: { Loader, CartProductsTable },
	data() {
		return {
			form: {
				name: '',
				lastname: '',
				email: '',
				phone: {
					countryCode: 'UY',
				},
				businessName: null,
				businessRut: null,
				deliveryMethod: null,
				deliveryAgency: null,
				deliveryLocality: null,
				deliveryAddress: null,
				deliveryComments: null,
			},
			loading: false,
		}
	},
	computed: {
		cart() {
			return this.$store.getters.cart
		},
		productsValidated() {
			let error = false
			if (this.cart.products.length <= 0) error = true
			this.cart.products.map((p) => {
				if (p.stockInsufficient) error = true
			})

			return !error
		},
	},
	methods: {
		save() {
			if (!this.loading) {
				this.loading = true

				const data = {
					client: {
						name: this.form.name,
						lastname: this.form.lastname,
						phone: this.form.phone,
						email: this.form.email,
						phone: this.form.phone,
					},
					businessName: this.form.businessName,
					businessRut: this.form.businessRut,
					deliveryMethod: this.form.deliveryMethod,
					deliveryAgency: this.form.deliveryAgency,
					deliveryLocality: this.form.deliveryLocality,
					deliveryAddress: this.form.deliveryAddress,
					deliveryComments: this.form.deliveryComments,
					products: this.cart.products.map((p) => {
						return {
							product: p.product.id,
							qty: p.qty,
						}
					}),
					comments: this.form.comments,
				}
				this.$apollo
					.mutate({
						mutation: gql`
							mutation($data: OrderInput!) {
								orderCreate(data: $data) {
									id
									code
									client {
										name
										lastname
										email
										document {
											type
											number
										}
									}
								}
							}
						`,
						variables: {
							data,
						},
					})
					.then(({ data }) => {
						this.emptyCart()
						this.$gtag.event('orderCreated', { orderCode: data.orderCreate.code })
						this.$router.push(`/order/${data.orderCreate.code}/pay`)
					})
					.catch((err) => {
						console.log(err)
						this.loading = false
					})
			}
		},
	},
}
</script>
<style scoped>
.cart {
	width: 100%;
}

.section-title {
	display: flex;
	justify-content: center;
	min-height: 50px;
	flex-direction: column;
}
.section-title .label {
	font-size: 18px;
	font-weight: 500;
	line-height: 18px;
}
.section-title p {
	margin: 0px;
	color: #888;
}

.side-content {
	margin: auto;
	max-width: 400px;
}
/* 
.products-table tr {
	border-bottom: 1px solid #dee2e6;
}
.products-table td,
.products-table tr:last-child {
	border: none;
}
.products-table td {
	vertical-align: middle;
} */

/* .product-detail {
	display: flex;
	align-items: center;
}
.product-detail h3 {
	font-size: 15px;
	font-weight: 600;
}
.product-detail p {
	margin: 0px;
}
.product-detail img {
	max-width: 90px;
} */

/* .prices-table {
}
.prices-table tr td:last-child {
	text-align: right;
}

.cart-section {
	opacity: 0.6;
}
.cart-section.active {
	opacity: 1;
} */

/* div /deep/ .formulate-input .formulate-input-element {
	max-width: 100%;
	margin-bottom: 0.1em;
}

@media (max-width: 400px) {
	.product-detail img {
		display: none;
	}
}
@media (min-width: 750px) and (max-width: 996px) {
	.product-detail img {
		display: none;
	}
} */
</style>
